import React from 'react'

import { Button, Typography } from '@material-ui/core'

import Container from '../../../components/Container'

import t from '../../../translations'

const PollSaved = ({ pollData }) => {
  // Zwykłe sprawdzenia zamiast _.get: cały lodash (72,6 KB w paczce JS) był tu tylko dla tych dwóch odczytów.
  const template = pollData && pollData.template
  const reviewLink = template && template.reviewLink
  const reviewLabel = template && template.reviewLabel

  return (
    <Container>
      <div style={{ textAlign: 'center' }}>
        <Typography variant={'h5'}>
          {t.pollView.pollIsSaved}
        </Typography>
        {
          reviewLink ?
            <>
              <br />
              <Button
                href={reviewLink}
                variant={'contained'}
                color={'primary'}
              >
                {reviewLabel}
              </Button>
            </>
            :
            null
        }
      </div>
    </Container>
  )
}

export default PollSaved